import { ChargebacksTabs } from "globalConstants";
import { hasPermissions, permissionList } from "helpers";

export const tabs = [
	{
		path: ChargebacksTabs.AllMerchants.name,
		name: ChargebacksTabs.AllMerchants.displayName,
		requiredPermissions: permissionList.PeriodicCreditReview,
	},
	{
		path: ChargebacksTabs.InReview.name,
		name: ChargebacksTabs.InReview.displayName,
		requiredPermissions: permissionList.PeriodicCreditReview,
	},
	{
		path: ChargebacksTabs.Historical.name,
		name: ChargebacksTabs.Historical.displayName,
		requiredPermissions: permissionList.PeriodicCreditReview,
	},
];

export const getChargebacksTabsPaths = () =>
	tabs
		.filter(tab => hasPermissions(tab.requiredPermissions))
		.map(tab => tab.path);
